import React from 'react'

import influencerData from '../../data-influencer/paola'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const Paola = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default Paola
